import UseAxios from '../../Api/http/http';
import { fetchUserInfo } from '../../Api/request/integration';

// Define the function to fetch user information
export const fetchUserInfoFromZoho = async (fullName) => {
  try {
    const requestData = {
      filterValues: { fullName: fullName },
      fieldsToShow: ['employeeId', 'fullName', 'photoSignedUrl', 'emailId', 'workExperience'],
    };

    const response = await UseAxios(fetchUserInfo(requestData));
    const users = response?.data?.users?.data || [];

    const sortedUsers = sortUsersByFullName(users, fullName);

    return sortedUsers.slice(0, 10);
  } catch (error) {
    console.error('Error fetching user info:', error);
    throw error;
  }
};

// Helper function to sort users by full name
const sortUsersByFullName = (users, searchTerm) => {
  return users.sort((userA, userB) => {
    const nameA = userA.fullName.toLowerCase();
    const nameB = userB.fullName.toLowerCase();
    const lowerCaseSearchTerm = searchTerm.toLowerCase();

    const startsWithA = nameA.startsWith(lowerCaseSearchTerm);
    const startsWithB = nameB.startsWith(lowerCaseSearchTerm);

    if (startsWithA && !startsWithB) return -1;
    if (!startsWithA && startsWithB) return 1;

    return nameA.localeCompare(nameB);
  });
};
